import React from 'react';
import { useDragLayer } from 'react-dnd';
import { getItemStyles } from '@rs-ui/components/utils/gridUtils';

const layerStyles = {
	position: 'fixed',
	pointerEvents: 'none',
	zIndex: 100,
	left: 0,
	top: 0,
};

const DataGridColumnDragLayer = () => {
	const { item, isDragging, currentOffset } = useDragLayer(monitor => ({
		item: monitor.getItem(),
		isDragging: monitor.isDragging(),
		currentOffset: monitor.getSourceClientOffset(),
	}));

	if (!isDragging) {
		return null;
	}

	return (
		<div style={layerStyles}>
			<div style={getItemStyles(currentOffset)}>
				{/* Custom drag preview UI */}
				<div
					style={{
						width: 'auto',
						height: 'auto',
						border: '2px solid #364E5F',
						borderRadius: '15px',
						background: '#364E5F',
						color: '#42A5F5',
						padding: '8px',
						textAlign: 'center',
					}}
				>
					{item.label}
				</div>
			</div>
		</div>
	);
};

export default DataGridColumnDragLayer;
